import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SuperCodeService {

  constructor() { }
}
